export default {"src":"/_next/static/media/icone_zaori_branco.08515cbf.svg","height":1080,"width":1080,"blurWidth":0,"blurHeight":0};